// @ts-nocheck
import UserService from '../../services/UserService';
import { deleteAutToken, setAuthToken } from '../../utils/auth';
import { AUTH_USER_FETCHING, AUTH_USER_LOGGED_IN, AUTH_USER_LOGGED_OUT, SET_LOGIN_FORM_CHANGED } from '../types';
import { notification } from 'antd';

export const loginUser =
    ({ username, password }) =>
    async dispatch => {
        let { isExist, isValid } = await UserService.loginUser({ username, password });

        dispatch(setLoginForm({ isValid, isExist, username }));

        return { isValid, isExist };
    };

export const getCurrentUser = () => async dispatch => {
    const { info, item: user } = await UserService.getCurrentUser();

    if (info.success && user && Object.keys(user.roleNames).length) {
        dispatch(setUserLoggedIn(user));

        return user;
    }

    return null;
};

export const logoutUser = () => dispatch => {
    UserService.logoutUser();
    deleteAutToken();
    dispatch(setUserLoggedOut());
};

export const setUserLoggedIn = user => ({
    type: AUTH_USER_LOGGED_IN,
    payload: user,
});

export const setLoginForm = payload => ({
    type: SET_LOGIN_FORM_CHANGED,
    payload,
});

export const setUserLoggedOut = () => ({
    type: AUTH_USER_LOGGED_OUT,
});

export const setUserFetching = state => ({
    type: AUTH_USER_FETCHING,
    payload: state,
});

export const generateQr = params => async dispatch => {
    await UserService.generateQr(params);

    notification.success({ message: 'OTP set-up instructions was sent to your email' });
};

export const recoverQr = params => async dispatch => {
    await UserService.recoverQr(params);

    notification.success({ message: 'OTP set-up instructions was sent to your email' });
};

export const validateOtp = params => async dispatch => {
    const response = await UserService.validateOtp(params);

    if (!response.token) {
        notification.destroy();
        notification.error({
            message: 'Invalid OTP',
        });
        return null;
    }

    const { token } = response;
    setAuthToken(token);

    await dispatch(getCurrentUser());

    dispatch(setLoginForm(null));
};
